import type { CourierId } from '../ids/ids';
import { CHARACTER_STATS } from '../CharacterStats';

/**
 * Параметры курьера в игре (GDD: скорость, управляемость, мощь).
 * Числа — относительные шкалы; маппинг в физику — в слое симуляции.
 * Данные — из {@link CHARACTER_STATS} (`control` = handling).
 */
export type CourierRunStats = {
  speed: number;
  handling: number;
  /** GDD «мощь»: размер персонажа и базовое число жизней-сердечек. */
  power: number;
};

/** Опорная скорость для нормализации к множителю к `baseForwardSpeed` уровня (середина шкалы GDD 3–10). */
const COURIER_SPEED_REFERENCE = 6;

export function getCourierRunStats(courierId: CourierId): CourierRunStats {
  const stats = CHARACTER_STATS[courierId];
  return {
    speed: stats.speed,
    handling: stats.control,
    power: stats.power,
  };
}

/**
 * Множитель «вперёд» от статы курьера: `effectiveBase ≈ level.baseForwardSpeed * это значение`.
 * Уточнить после плейтеста (tech-spec §6.2).
 */
export function getCourierForwardSpeedMultiplier(courierId: CourierId): number {
  return getCourierRunStats(courierId).speed / COURIER_SPEED_REFERENCE;
}

/**
 * Число жизней (засчитываемых столкновений) до мини-игры по стате «мощь».
 * Мощь 1–3 → 3; 4–6 → 4; 7–10 → 5.
 */
export function getCourierMaxLives(courierId: CourierId): number {
  const power = getCourierRunStats(courierId).power;
  if (power <= 3) {
    return 3;
  }
  if (power <= 6) {
    return 4;
  }
  return 5;
}

/** Нормализованная стата для UI-полос (0…1). */
export function getCourierStatBarValue(
  courierId: CourierId,
  stat: keyof CourierRunStats,
): number {
  return getCourierRunStats(courierId)[stat] / 10;
}
